// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1WI5z","buttons":"PendingPaymentAlert_buttons__BNpRt"};